import React from 'react'
import ReactDOMServer from 'react-dom/server';
import moment from 'moment'
import '../../../assets/css/a4.css';
import {inWords} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'
import HistoryChoser from '../historyChoser'

const TableCustomPadding = () =>(
  <style>
{".preview-a4 .table>tbody>tr>td { padding: 8px;}"}
  </style>
)

export default class InvoiceTrader extends React.Component {

  render() {


        let company = this.props.company
        let invoice = this.props.invoice

        console.log(invoice)
        let historyRecords = this.props.history
        let settings = this.props.settings || getUserSettings()
        let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
        let invoice_date = moment(invoice.date).format('D-MM-YYYY')
        let billto_1, billto_2, billFrom
        let place_of_supply
        let shipping_address
        let optionalRow = false
        let table_cols = 6
        let invoice_label = "INVOICE"
        let show_mrp_column = false
        let show_container_unit = false
        let serial = invoice.series_name + invoice.series_counter
        if(document) {
          const s = ReactDOMServer.renderToStaticMarkup(serial)
          document.title = s
        }
        let bankDetails, declartion, tnc
        let purchase_order

        let settingOptions = settings.options || {}
        let options, historySelection

        if(typeof settings !== "undefined" && settings !== null) {
          if(settings) {
            options = settings.options
          }
          if(options && options.show_invoice_history) {
            historySelection = <HistoryChoser handleHistorySelect={this.props.handleHistorySelect} records ={historyRecords} />
          }
           if(settings.show_invoice_mrp_column) {
             show_mrp_column = true
             table_cols = table_cols+1
           }
           if(settings.show_invoice_container_info) {
             show_container_unit = true
             table_cols = table_cols+1
           }
           if(settings.invoice_label) {
             invoice_label = <div className="invoice-name" style={{fontFamily:'serif'}}>
                <span>{settings.invoice_label}</span>
             </div>
           }

           if(settings.show_invoice_tnc) {

           tnc = <div><u>Terms and Conditions</u>
                 <div><p>{settings.invoice_tnc}</p></div>
                 </div>
           }

           if(settings.show_invoice_declaration) {

           declartion = <div><u>Declaration</u>
                 <div><p>{settings.invoice_declaration}</p></div>
                 </div>
           }

           if(settings.show_invoice_bankdetails) {

             bankDetails = <div><div className="row">
                   <div className="col-xs-12 space-small-bottom"><strong >Bank Details</strong></div>
                 <div className="col-xs-6">Bank Name</div>
                 <div className="col-xs-6">{company.bank_name}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">Account No</div>
                   <div className="col-xs-6">{company.account_no}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">IFSC</div>
                   <div className="col-xs-6">{company.ifsc_code}</div>
                 </div>
                 <div className="row">
                   <div className="col-xs-6">Branch </div>
                   <div className="col-xs-6">{company.branch_name}</div>
                 </div>

                 </div>
           }
           let options = settings.options

           if(options && options.enable_invoice_purchase_order) {
             purchase_order = <div className="space-small">Purchase Order: <strong>{invoice.purchase_order_no}</strong></div>
           }
        }

        let company_gstin, company_phone, company_name, company_address, company_additional_params

        if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
          company_gstin = <span><strong>{"GSTIN: " +company.gstin}</strong></span>
        }
        if(company.additional_params && company.additional_params.length) {
          let additional_params_list = company.additional_params.map(function(param, i) {
            return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
          })
          company_additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
        }

        if(typeof company.phone !== "undefined" && company.phone.length > 0) {
          company_phone = <span >{"Ph: " +company.phone}</span>
        }
        if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
          company_name = <div className="company-name text-uppercase" style={{fontSize:26, fontWeight:400, fontFamily:"serif"}}>

                          {company.company_name}
                        </div>
        }
        company_address = <div className="space-small-bottom"> {company.address} {company.city} {company.state} {company.pin}</div>


        let transportSection

        let transportlabel = invoice.transportlabel, vehicle_number, WAY_BILL_NO
        if(typeof transportlabel !== "undefined" && transportlabel !== null) {

          let t_label_name, t_bill_no, t_lr_no, t_challan_no, t_vehicle_no, t_ship_by, t_transporter_name, t_transporter_id, t_transporter_gstin
          t_bill_no = transportlabel.bill_no
          if (t_bill_no) {
              WAY_BILL_NO = <div className="space-small-bottom">
                Way Bill No: {transportlabel.bill_no}
              </div>
          }

          t_label_name = transportlabel.label_name
          if(t_label_name === "way_bill_no") {
            t_label_name = <strong>Way Bill No: </strong>
          }
          else if(t_label_name === "e_sugam_no"){
            t_label_name = <strong>E Sugam No: </strong>
          }
          else if (t_label_name === "eway_bill_no") {
            t_label_name = <strong>EWay Bill No: </strong>
          }
          t_vehicle_no = transportlabel.vehicle_no
          vehicle_number = transportlabel.vehicle_no
          if(typeof vehicle_number !== "undefined" && vehicle_number !== null && vehicle_number.length > 0) {
            vehicle_number = <div className="space-small"><span>Vehicle No: <strong>{vehicle_number}</strong></span></div>
          }
          t_challan_no = transportlabel.challan_no
          if(typeof t_challan_no !== "undefined" && t_challan_no !== null && t_challan_no.length > 0) {
            t_challan_no = <span><strong>Challan No: </strong> {t_challan_no}</span>
          }
          t_lr_no = transportlabel.lr_no
          if(typeof t_lr_no !== "undefined" && t_lr_no !== null && t_lr_no.length > 0 ) {
            t_lr_no = <span><strong>LR No: </strong> {t_lr_no}</span>
          }

          t_ship_by = transportlabel.ship_by
          if(typeof t_ship_by !== "undefined" && t_ship_by !== null && t_ship_by.length> 0) {
            t_ship_by = <span><strong>Ship By: </strong> {t_ship_by}</span>
          }
          t_transporter_name = transportlabel.transporter_name
          if(typeof t_transporter_name !== "undefined" && t_transporter_name !== null && t_transporter_name.length > 0) {
            t_transporter_name = <span><strong>Transporter Name: </strong> {t_transporter_name}</span>
          }
          t_transporter_id = transportlabel.transporter_id
          if(typeof t_transporter_id !== "undefined" && t_transporter_id !== null && t_transporter_id.length > 0) {
            t_transporter_id = <span><strong>Transporter ID: </strong> {t_transporter_id}</span>
          }
          t_transporter_gstin = transportlabel.transporter_gstin
          if(typeof t_transporter_gstin !== "undefined" && t_transporter_gstin !== null && t_transporter_gstin.length > 0) {
            t_transporter_gstin = <span><strong>Transporter GSTIN: </strong> {t_transporter_gstin}</span>
          }

          transportSection = <div>
              <ul className="list-inline">
                <li>{t_label_name} {t_bill_no}</li>
                <li>{t_vehicle_no}</li>
                <li>{t_lr_no}</li>
                <li>{t_challan_no}</li>
                <li>{t_ship_by}</li>
                <li>{t_transporter_name}</li>
                <li>{t_transporter_id}</li>
                <li>{t_transporter_gstin}</li>
              </ul>
          </div>
        }


        if(typeof invoice.client !== "undefined" && invoice.client !== null) {
          place_of_supply = invoice.client.city
          let client_gstin
          let client_phone
          if(typeof invoice.client.gstin !== "undefined" && invoice.client.gstin !== null && invoice.client.gstin.length > 0) {
            client_gstin = "GSTIN-"+invoice.client.gstin
          }
          if(typeof invoice.client.phone !== "undefined" && invoice.client.phone !== null && invoice.client.phone.length > 0) {
            client_phone = "Ph: " + invoice.client.phone
          }
          if(!invoice.client.same_as_biiling) {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.shipping_address}
              </div>
              <div className="gray">
              <span className="gray">
              {invoice.client.shipping_city}
              </span>
              <span className="gray">
              {" "+invoice.client.shipping_state} {" "+invoice.client.shipping_pin}
              </span>
              <span className="gray">
              {invoice.client.shipping_state_code.length > 0 ? " State Code: "+invoice.client.shipping_state_code: ""}
              </span>

              </div>
              <div className="gray">
                  {invoice.client.shipping_state}-{invoice.client.shipping_pin}
              </div></div>
          }
          else {
            shipping_address = <div>  <div className="gray">
                    <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div className="gray">
                <span className="gray">
                {invoice.client.city}
                </span>
                <span className="gray">
                {" "+invoice.client.state} {" "+invoice.client.pin}
                </span>
              <span className="gray">
              {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
              </span>

              </div>
              </div>
          }

          billto_1 =  <div className="row"><div className="col-xs-12">
            <div className="">
            <strong>Bill To</strong>
              <div className="gray">
                  <strong>{invoice.client.name}</strong>
              </div>
              <div className="gray">
                  {invoice.client.address}
              </div>
              <div>
                <span className="gray">
               {invoice.client.city} {" "+invoice.client.state}
                </span>
                <span className="gray">
                {" "+invoice.client.pin}
                </span>
                <span className="gray">
                {invoice.client.state_code.length > 0 ? " State Code: "+invoice.client.state_code: ""}
                </span>
              </div>
              <div>
              </div>
              <div className="gray">
                 {client_gstin}
              </div>
            </div>
          </div></div>

          billto_2 = <div className="row"><div className="col-xs-12">
            <div className="">
            <strong>Ship To</strong>
              {shipping_address}
            </div>
            <div>
              {client_phone}
            </div>
          </div></div>




        }
        // end of billto
        let itemsHeader = <thead>
          <tr className="active">
            <th>S.No</th>
            <th className="table-item">HSN</th>
            <th className="table-item">Name</th>
            <th className="text-right">Qty</th>
            <th className="text-right">Unit Price</th>
            <th className="text-right">Taxable Price</th>
          </tr>
        </thead>

        let items, summaryRow
        if(invoice.saleitem_set.length > 0) {

          invoice.saleitem_set.sort((a,b)=>{
            return a.tableIndex - b.tableIndex
          })

          items = invoice.saleitem_set.map((saleitem, index)=>{
            let discountCol, cgstcol, sgstcol, igstcol

            let unit_price = Number(saleitem.selling_basic_rate),
            taxable_price = parseFloat(saleitem.price).toFixed(2),
            item_total = parseFloat(saleitem.total).toFixed(2)

            let mrp_column
            if(show_mrp_column) {
              mrp_column = <td className="text-right">{parseFloat(saleitem.mrp).toFixed(2)}</td>
            }


            let extra = saleitem.extra
            let extraValues
            if(extra && extra.addons) {
              let itemAddons = extra.addons || []
              extraValues = itemAddons.map(function(param, i) {

                    return <div key={i}><span className="gray"><strong>{param.key}</strong> {param.value}</span></div>


              })


            }


            return <tr key={index}>
              <td>{saleitem.tableIndex}</td>
              <td><div>{saleitem.hsn}</div> </td>
              <td><div>{saleitem.name}</div>
                {extraValues}
          </td>
              <td className="text-right">
                <div>{Number(saleitem.quantity)}</div>
              </td>
              <td className="text-right">{unit_price}</td>
              <td className="text-right">{taxable_price}</td>
          </tr>
          })
        }


        let summaryRowSpan = 3

        let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0, summarySGST=0, summaryTotal=0, summaryTCS=0
        let percentages={cgst:{}, sgst:{}, igst:{}, tcs:{}}
        for (var i = 0; i < invoice.saleitem_set.length; i++) {
            const si = invoice.saleitem_set[i]
            summaryQuantity = summaryQuantity + parseFloat(si.quantity)
            summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
            summaryTaxable = summaryTaxable + parseFloat(si.price)
            summaryIGST = summaryIGST + parseFloat(si.igst_amount)
            summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
            summarySGST = summarySGST + parseFloat(si.sgst_amount)
            summaryTCS = summaryTCS + (si.tcs_value ? parseFloat(si.tcs_value): 0)
            summaryTotal = summaryTotal + parseFloat(si.total)
            const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst
            const igst_s_amount = parseFloat(si.igst_amount)
            const cgst_s_amount = parseFloat(si.cgst_amount)
            const sgst_s_amount = parseFloat(si.sgst_amount)
            const taxable_price = parseFloat(si.price)
            const tcs_value  = si.tcs_value ? parseFloat(si.tcs_value): 0
            const total = parseFloat(si.total)


            let tcs_percentages = percentages['tcs']
            if(typeof tcs_percentages[si.tcs_pct] !== "undefined") {
              let t = tcs_percentages[si.tcs_pct]
              t.total = t.total + tcs_value
            }
            else {
              tcs_percentages[si.tcs_pct] = {total:tcs_value}
            }
            percentages['tcs'] = tcs_percentages


            let cgst_percentages = percentages['cgst']

            if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
              let s = cgst_percentages[unique_cgst_pct]

              s.cgst_amount= s.cgst_amount + cgst_s_amount
              s.sgst_amount= s.sgst_amount + sgst_s_amount
              // s.igst_amount= s.igst_amount + igst_s_amount
              s.taxable_price = s.taxable_price + taxable_price
              s.total = s.total + total

            }
            else {
              cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
              //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
            }
            percentages['cgst'] = cgst_percentages

            let igst_percentages = percentages['igst']

            if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
              let s = igst_percentages[unique_igst_pct]
              s.igst_amount= s.igst_amount + igst_s_amount
              s.taxable_price = s.taxable_price + taxable_price
              s.total = s.total + total
            }
            else {
              igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
              //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
            }

            percentages['igst'] = igst_percentages
          }


          if(invoice.additional_charges) {
            invoice.additional_charges.forEach((charge,id)=>{

              if(charge.value) {
                summaryTaxable = summaryTaxable + parseFloat(charge.value)
                summaryTotal = summaryTotal + parseFloat(charge.total)
                if(charge.tax_igst_value) {
                  summaryIGST = summaryIGST + parseFloat(charge.tax_igst_value)
                  summaryCGST = summaryCGST + parseFloat(charge.tax_cgst_value)
                  summarySGST = summarySGST + parseFloat(charge.tax_cgst_value)
                }
              }


            })
          }


          summaryDiscount = parseFloat(summaryDiscount).toFixed(2)
          summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
          summaryIGST = parseFloat(summaryIGST).toFixed(2)
          summaryCGST = parseFloat(summaryCGST).toFixed(2)
          summarySGST = parseFloat(summarySGST).toFixed(2)
          summaryTCS = parseFloat(summaryTCS).toFixed(2)
          summaryTotal = parseFloat(summaryTotal).toFixed(2)

          let cgst_td_cells=[],  sgst_td_cells=[], igst_td_cells=[], additional_charges_cells=[], additional_taxes_cells=[], tcs_cells=[]
          let additional_charges = invoice.additional_charges

          if(additional_charges && additional_charges.length) {
            additional_charges_cells = additional_charges.map((ac, id)=>{
              if(ac.value) {

                summaryRowSpan = summaryRowSpan+1
                return <tr className="text-right" key={id}>
                    <td colSpan="3" style={{borderBottom:'1px solid transparent'}}></td>
                    <td colSpan="2" >{ac.key}</td>
                    <td>{parseFloat(ac.value).toFixed(2)}</td>
                </tr>

              }


            })

            additional_taxes_cells = additional_charges.map((ac, id)=>{
              if(ac.value && ac.tax_pct) {

                summaryRowSpan = summaryRowSpan+1
                return <tr className="text-right" key={id}>
                    <td colSpan="2" >GST @ {parseFloat(ac.tax_pct).toFixed(2)}</td>
                    <td>{parseFloat(ac.total - ac.value).toFixed(2)}</td>
                </tr>

              }


            })
          }

          if(invoice.add_tcs){
              const tcsPercentages = percentages['tcs']
              let percentageKeys = Object.keys(tcsPercentages)
              if(percentageKeys.length ){
                percentageKeys.sort((a,b)=>{return a-b})
              }
              for (var i=0; i<percentageKeys.length; i++) {
                const pct_key = percentageKeys[i]
                const s = tcsPercentages[pct_key]
                const tcs_amount = parseFloat(s.total).toFixed(2)
                tcs_cells.push(<tr className="text-right" key={i}><td colSpan={2}>TCS @ {pct_key}</td><td>{tcs_amount}</td></tr>)
                summaryRowSpan = summaryRowSpan+1
              }

          }

          if(invoice.is_igst) {

            const igstPercentages = percentages['igst']
            let percentageKeys  = Object.keys(igstPercentages)
            let igst_tax_total = 0.0, tax_total=0.0
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })
                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   const s = igstPercentages[pct_key]
                   const igst_amount = parseFloat(s.igst_amount).toFixed(2)
                   igst_td_cells.push(<tr className="text-right" key={i}><td colSpan={2}>IGST @ {pct_key}</td><td>{igst_amount}</td></tr>)
                   summaryRowSpan = summaryRowSpan+1
                 }
            }



          }
          else {
            const cgstPercentages = percentages['cgst']
            let percentageKeys  = Object.keys(cgstPercentages)
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })


                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   const s = cgstPercentages[pct_key]

                   const cgst_amount = parseFloat(s.cgst_amount).toFixed(2)
                   const sgst_amount = parseFloat(s.sgst_amount).toFixed(2)
                   cgst_td_cells.push(<tr className="text-right" key={i}><td colSpan={2}>CGST @ {pct_key}</td><td>{cgst_amount}</td></tr>)
                   sgst_td_cells.push(<tr className="text-right" key={i}><td colSpan={2}>SGST @ {pct_key}</td><td>{cgst_amount}</td></tr>)
                   summaryRowSpan = summaryRowSpan+2
                 }
            }
          }



          let roundOffValue= parseFloat(invoice.total) - parseFloat(summaryTotal)

          if(roundOffValue >= 0) {
              roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
          }
          else {
              roundOffValue = parseFloat(roundOffValue).toFixed(2)
          }

        let additional_params = invoice.additional_params
        let additional_key_values
        let camp_value, from_date_value, to_date_value
        if(typeof additional_params !== "undefined" && additional_params !== null) {
          let camp = additional_params.find(param=>param.key.toLowerCase()=="camp")
          if(typeof camp !== "undefined" && camp !== null) {
            camp_value = <div className="space-small">
                          Camp: <strong>{camp.value}</strong>
                        </div>
          }
          let fromdate = additional_params.find(param=>param.key.toLowerCase()=="from")
          if(typeof fromdate !== "undefined" && fromdate !== null) {
            from_date_value = <div className="space-small">
                          {fromdate.key}: <strong>{fromdate.value}</strong>
                        </div>
          }
          let todate = additional_params.find(param=>param.key.toLowerCase()=="to")
          if(typeof todate !== "undefined" && todate !== null) {
            to_date_value = <div className="space-small">
                           {todate.key}: <strong>{todate.value}</strong>
                        </div>
          }

        }

        let header_1 =<div className="row">
                <div className="col-xs-6">
                  {company_gstin} {company_additional_params}
                </div>
                <div className="col-xs-6 text-right">
                  {company_phone}
                </div>
        </div>

        let header_2 = <div className="row">
              <div className="col-xs-12 text-center">
                {company_name}
              </div>
        </div>

        let supply_info_1 = <div className="row"><div className="col-xs-12">
          <div className="space-small">
          Place Of Supply: <strong>{place_of_supply}</strong>
          </div>
          {camp_value}
        </div></div>

        let supply_info_2 = <div className="row"><div className="col-xs-12">
          <div className="space-small" style={{fontSize:'110%'}}>
          Invoice No: <strong>{serial}</strong>
          </div>
          <div className="space-small">
          Date: <strong>{invoice_date}</strong>
          </div>
          <div>
            {purchase_order}
          </div>
          {vehicle_number}
          {from_date_value}
          {to_date_value}

        </div></div>


      let footer = <div className="row">
            <div className="col-xs-6">
              {WAY_BILL_NO}
              {tnc}
              {declartion}
            </div>
            <div className="col-xs-6 text-right">
                <div className="space-large-bottom">For <span style={{fontFamily:'serif'}}>{company.company_name}</span></div>

                <div>Authorized Signature</div>
            </div>
      </div>

      let totalDiscount
      if(invoice.totalDiscount >0) {
        totalDiscount =<tr className="text-right"> <td colSpan={2 }>Discount</td> <td>{invoice.totalDiscount}</td> </tr>
        summaryRowSpan++
      }




    return   <div style={{position:'relative'}}>
      <div className="hidden-print" style={{position:'absolute', left:0}}>
        {historySelection}
      </div>

    <div className="preview-a4" ref={(pdf)=>{this.pdf = pdf}} id="printablePreview">
      <TableCustomPadding />
          <div className="invoice-name text-right">{this.props.print_type}</div>
                <table className="table table-bordered">
                <tbody>

                    <tr>
                    <td colSpan={6}>
                    {header_1}
                      {header_2}
                      <div className="text-center">
                      {company_address}
                      </div>
                    </td>
                    </tr>
                    <tr>
                    <td colSpan={6}>
                    <div className="text-center" style={{fontFamily:'serif'}}>
                    {invoice_label}
                    </div>

                    </td>
                    </tr>
                    <tr>
                    <td colSpan={3}>
                    {supply_info_1}
                    </td>
                    <td colSpan={3}>
                    {supply_info_2}
                    </td>
                    </tr>

                    <tr>
                    <td colSpan={3}>
                    {billto_1}
                    </td>
                    <td colSpan={3}>
                    {billto_2}
                    </td>
                    </tr>

                    <tr className="active">
                      <th>S.No</th>
                      <th className="table-item">HSN</th>
                      <th className="table-item">Name</th>
                      <th className="text-right">Qty</th>
                      <th className="text-right">Unit Price</th>
                      <th className="text-right">Taxable Price</th>
                    </tr>
                    {items}
                    {additional_charges_cells}
                    <tr>
                      <td colSpan={3} rowSpan={summaryRowSpan}>
                      {bankDetails}
                      </td>

                      <td className="text-right " colSpan={2}>
                      Amount Before Tax
                      </td>
                      <td className="text-right">
                        {summaryTaxable}
                      </td>
                    </tr>
                    {cgst_td_cells}

                    {sgst_td_cells}
                    {igst_td_cells}
                    {additional_taxes_cells}
                    {tcs_cells}
                    {totalDiscount}
                    <tr>
                      <td className="text-right " colSpan={2}>
                      Round Off
                      </td>
                      <td className="text-right">
                        {roundOffValue}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-right " colSpan={2}>
                      Total
                      </td>
                      <td className="text-right">
                        {invoice.total}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={6} className="text-right">
                      <ul className="list-inline">
                        <li>
                        Amount In Words:
                        </li>
                        <li>
                        {inWords(invoice.total)}
                        </li>
                      </ul>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={6}>
                        {footer}
                      </td>
                    </tr>

                    </tbody>
                </table>
                <div className="text-center" style={{fontSize:'90%'}}>
                    {settingOptions.jurisdiction_notes}
                </div>
                <div>{settingOptions.show_goodsbill_brand ? brandRow: ""}</div>
    </div>
  </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/invoicetrader.js